import {Fragment} from "react";
import ChannelCard from "../../Utilities/ChannelCard";
import logoDixa from "../../../../../images/logos/logo_dixa.png";
import DixaSetupModal from "./DixaSetupModal";
import useDixaSetup from "./useDixaSetup";

export default function DixaProvider() {
    const { initiateDixaSetup, dixaSetupOpen, handleDixaSetupOpen, handleDixaSetupClose } = useDixaSetup();

    return(
        <Fragment>
            <ChannelCard
                icon={logoDixa}
                label={'Dixa'}
                description={'Resolve support tickets and clear your backlog'}
                onClick={initiateDixaSetup}
            />
            <DixaSetupModal
                open={dixaSetupOpen}
                handleOpen={handleDixaSetupOpen}
                handleClose={handleDixaSetupClose}
            />
        </Fragment>
    )
}